import { API_ENDPOINT } from "../config";

const API_URL = `${API_ENDPOINT}/weapon-templates`;

export const getWeaponTemplates = async (category = null) => {
  try {
    const url = category
      ? `${API_URL}/list?category=${category}`
      : `${API_URL}/list`;
    const response = await fetch(url);
    const data = await response.json();

    if (!data.success) {
      throw new Error(data.message || "Errore nel recupero dei template armi");
    }

    return data;
  } catch (error) {
    console.error("Error fetching weapon templates:", error);
    throw error;
  }
};

export const getWeaponCategories = async () => {
  try {
    const response = await fetch(`${API_URL}/categories`);
    const data = await response.json();

    if (!data.success) {
      throw new Error(data.message || "Errore nel recupero delle categorie");
    }

    return data;
  } catch (error) {
    console.error("Error fetching weapon categories:", error);
    throw error;
  }
};

export const getWeaponTemplateById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/${id}`);
    const data = await response.json();

    if (!data.success) {
      throw new Error(data.message || "Errore nel recupero del template arma");
    }

    return data;
  } catch (error) {
    console.error("Error fetching weapon template:", error);
    throw error;
  }
};
